// extracted by mini-css-extract-plugin
module.exports =  {"logo-link":"fhefnBqp1p0a6WtTNMX8","logo-link--ec":"PNSNXksMo01GonlDHogW","logo-link--eu":"Eo9zCxMMTy_r9aGPtzp6"};